export enum ZoneInputType {
  FREEZONE = 'freezone',
  RESTZONE = 'restzone'
}
